/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlUserFieldsFragment = {
  __typename: "User";
  uri: string;
  email: string;
  firstName: string;
  lastName: string;
  initials?: string | null;
  picture?: string | null;
  latestLoginAt?: string | null;
};

export const UserFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "userFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "initials" } },
          { kind: "Field", name: { kind: "Name", value: "picture" } },
          { kind: "Field", name: { kind: "Name", value: "latestLoginAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlUserFieldsFragment, unknown>;
